export const START_EDITING = 'START_EDITING';
export function startEditing() {
  return {
    type: START_EDITING,
  };
}

export const STOP_EDITING = 'STOP_EDITING';
export function stopEditing() {
  return {
    type: STOP_EDITING,
  };
}
